import { Fragment, useContext } from "react";
import { useNavigate } from "react-router";
import { Button } from "rizzui";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import PageHeader from "../../../layout/shared/page-header";
import { menuRoutes } from "../../../router/menu";
import cn from "../../../utils/classNames";
import ListExpirations from "./ListExpirations";

const ExpirationListWrapper = () => {

    const { userCan } = useContext(PrivilegeContext);
    const navigate = useNavigate();

    const breadCrumb = [
        { name: 'Ventas' },
        { name: 'Gestión de contratos' },
        { name: 'Vencimientos', href: menuRoutes.expirations.path },
    ];

    return (
        <Fragment>
            <FiltersProvider>
                <PageHeader title="Listado de vencimientos" breadcrumb={breadCrumb}>
                    {userCan('create_expirations', 'expirations') && (
                        <Button
                            color="primary"
                            onClick={() => { navigate(menuRoutes.expirations.create) }}
                            className={cn(['mt-4 md:mt-0'])}
                        >
                            Crear vencimiento
                        </Button>
                    )
                    }
                </PageHeader>
                <ListExpirations />
            </FiltersProvider>
        </Fragment>
    );
}

export default ExpirationListWrapper;